import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {logout, onForbidden} from '../account/login';
import _ from 'lodash';
import moment from 'moment';
import {LOCATION_MAP} from '../../constants/constants';

const NO_COMMENT = 'No Comment';

//- Actions
export const fetchGetPaymentsHistoryForBAsFailed = createAction('FETCH_GET_BA_S_PAYMENTS_HISTORY_FAILED');
export const fetchGetPaymentsHistoryForBAsSuccess = createAction('FETCH_GET_BA_S_PAYMENTS_HISTORY_SUCCESS');
export const onGetPaymentsHistoryForBAsSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(fetchGetPaymentsHistoryForBAsSuccess(data));
    } else {
        dispatch(fetchGetPaymentsHistoryForBAs(currentPage - 1));
    }
};
export const onFetchGetPaymentsHistoryForBAs = createAction(
    'FETCH_GET_BA_S_PAYMENTS_HISTORY',
    (page, filters) => Api.getPaymentsHistoryForBAs(page, filters),
    () => ({
        apiCall: true,
        onSuccess: onGetPaymentsHistoryForBAsSuccess,
        onFail: fetchGetPaymentsHistoryForBAsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetPaymentsHistoryForBAs = (page) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForBAsPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForBAsPaymentsHistory(getState());
    let nameFilter = getNameFilterForBAsPaymentsHistory(getState());
    let countries = getCountryFilterForBAsPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForBAs(page, filters));
};

export const onUpdateDateFromFilterForBAsPaymentsHistory = createAction('UPDATE_DATE_FROM_FILTER_FOR_BA_S_PAYMENTS_HISTORY');
export const updateDateFromFilterForBAsPaymentsHistory = (dateFromFilter) => (dispatch, getState) => {
    let dateToFilter = getDateToFilterForBAsPaymentsHistory(getState());
    let nameFilter = getNameFilterForBAsPaymentsHistory(getState());
    let countries = getCountryFilterForBAsPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForBAs(0, filters));
    dispatch(onUpdateDateFromFilterForBAsPaymentsHistory(dateFromFilter));
};
export const onUpdateDateToFilterForBAsPaymentsHistory = createAction('UPDATE_DATE_TO_FILTER_FOR_BA_S_PAYMENTS_HISTORY');
export const updateDateToFilterForBAsPaymentsHistory = (dateToFilter) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForBAsPaymentsHistory(getState());
    let nameFilter = getNameFilterForBAsPaymentsHistory(getState());
    let countries = getCountryFilterForBAsPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForBAs(0, filters));
    dispatch(onUpdateDateToFilterForBAsPaymentsHistory(dateToFilter));
};
export const onUpdateNameFilterForBAsPaymentsHistory = createAction('UPDATE_NAME_FILTER_FOR_BA_S_PAYMENTS_HISTORY');
export const updateNameFilterForBAsPaymentsHistory = (nameFilter) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForBAsPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForBAsPaymentsHistory(getState());
    let countries = getCountryFilterForBAsPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForBAs(0, filters));
    dispatch(onUpdateNameFilterForBAsPaymentsHistory(nameFilter));
};


export const updateCountryFilterForBAsPaymentsHistory = createAction('UPDATE_COUNTRY_FILTER_FOR_BA_S_PAYMENTS_HISTORY');

export const onUpdateCountryFilterForBAsPaymentsHistory = (country) => (dispatch) => {
    let countries = country ? [country] : null;
    dispatch(updateCountryFilterForBAsPaymentsHistory(countries));
    dispatch(getBAsPaymentHistoryByCountryFilter(countries));
};

export const onUpdateCountryFilterByContinentForBAsPaymentsHistory = (continent) => (dispatch) => {
    let countries = continent ? LOCATION_MAP[continent] : null;
    dispatch(updateCountryFilterForBAsPaymentsHistory(countries));
    dispatch(getBAsPaymentHistoryByCountryFilter(countries));
};

export const getBAsPaymentHistoryByCountryFilter = (countries) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForBAsPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForBAsPaymentsHistory(getState());
    let nameFilter = getNameFilterForBAsPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };

    dispatch(onFetchGetPaymentsHistoryForBAs(0, filters));
};

export const fetchGetPaymentsHistoryForUniversitiesFailed = createAction('FETCH_GET_UNI_S_PAYMENTS_HISTORY_FAILED');
export const fetchGetPaymentsHistoryForUniversitiesSuccess = createAction('FETCH_GET_UNI_S_PAYMENTS_HISTORY_SUCCESS');
export const onGetPaymentsHistoryForUniversitiesSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0) {
        dispatch(fetchGetPaymentsHistoryForUniversitiesSuccess(data));
    } else {
        dispatch(fetchGetPaymentsHistoryForUniversities(currentPage - 1));
    }
};
export const onFetchGetPaymentsHistoryForUniversities = createAction(
    'FETCH_GET_UNI_S_PAYMENTS_HISTORY',
    (page, filters) => Api.getPaymentsHistoryForUniversities(page, filters),
    () => ({
        apiCall: true,
        onSuccess: onGetPaymentsHistoryForUniversitiesSuccess,
        onFail: fetchGetPaymentsHistoryForUniversitiesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetPaymentsHistoryForUniversities = (page) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForUniversitiesPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForUniversitiesPaymentsHistory(getState());
    let nameFilter = getNameFilterForUniversitiesPaymentsHistory(getState());
    let countries = getCountryFilterForUniversitiesPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForUniversities(page, filters));
};

export const onUpdateDateFromFilterForUniversitiesPaymentsHistory = createAction('UPDATE_DATE_FROM_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');
export const updateDateFromFilterForUniversitiesPaymentsHistory = (dateFromFilter) => (dispatch, getState) => {
    let dateToFilter = getDateToFilterForUniversitiesPaymentsHistory(getState());
    let nameFilter = getNameFilterForUniversitiesPaymentsHistory(getState());
    let countries = getCountryFilterForUniversitiesPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForUniversities(0, filters));
    dispatch(onUpdateDateFromFilterForUniversitiesPaymentsHistory(dateFromFilter));
};
export const onUpdateDateToFilterForUniversitiesPaymentsHistory = createAction('UPDATE_DATE_TO_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');
export const updateDateToFilterForUniversitiesPaymentsHistory = (dateToFilter) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForUniversitiesPaymentsHistory(getState());
    let nameFilter = getNameFilterForUniversitiesPaymentsHistory(getState());
    let countries = getCountryFilterForUniversitiesPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForUniversities(0, filters));
    dispatch(onUpdateDateToFilterForUniversitiesPaymentsHistory(dateToFilter));
};
export const onUpdateNameFilterForUniversitiesPaymentsHistory = createAction('UPDATE_NAME_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');
export const updateNameFilterForUniversitiesPaymentsHistory = (nameFilter) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForUniversitiesPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForUniversitiesPaymentsHistory(getState());
    let countries = getCountryFilterForUniversitiesPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };
    dispatch(onFetchGetPaymentsHistoryForUniversities(0, filters));
    dispatch(onUpdateNameFilterForUniversitiesPaymentsHistory(nameFilter));
};

export const updateCountryFilterForUniversitiesPaymentsHistory = createAction('UPDATE_COUNTRY_FILTER_FOR_UNI_S_PAYMENTS_HISTORY');

export const onUpdateCountryFilterForUniversitiesPaymentsHistory = (country) => (dispatch) => {
    let countries = country ? [country] : null;
    dispatch(updateCountryFilterForUniversitiesPaymentsHistory(countries));
    dispatch(getUniversitiesPaymentHistoryByCountryFilter(countries));
};

export const onUpdateCountryFilterByContinentForUniversitiesPaymentsHistory = (continent) => (dispatch) => {
    let countries = continent ? LOCATION_MAP[continent] : null;
    dispatch(updateCountryFilterForUniversitiesPaymentsHistory(countries));
    dispatch(getUniversitiesPaymentHistoryByCountryFilter(countries));
};

export const getUniversitiesPaymentHistoryByCountryFilter = (countries) => (dispatch, getState) => {
    let dateFromFilter = getDateFromFilterForUniversitiesPaymentsHistory(getState());
    let dateToFilter = getDateToFilterForUniversitiesPaymentsHistory(getState());
    let nameFilter = getNameFilterForUniversitiesPaymentsHistory(getState());

    let filters = {
        dateFrom: dateFromFilter ? moment(dateFromFilter).utc().format() : null,
        dateTo: dateToFilter ? moment(dateToFilter).utc().format() : null,
        name: nameFilter,
        countries
    };

    dispatch(onFetchGetPaymentsHistoryForUniversities(0, filters));
};

//- State
const initialState = {
    BAsData: null,
    BAsDateFromFilter: null,
    BAsDateToFilter: null,
    BAsNameFilter: '',
    BAsCountryFilter: null,
    BAsFetching: false,
    BAsError: null,
    BAsCurrentPage: null,
    BAsTotalPages: null,
    universitiesData: null,
    universitiesDateFromFilter: null,
    universitiesDateToFilter: null,
    universitiesNameFilter: '',
    universitiesCountryFilter: null,
    universitiesFetching: false,
    universitiesError: null,
    universitiesCurrentPage: null,
    universitiesTotalPages: null
};

//- Reducers
export default handleActions({
    FETCH_GET_BA_S_PAYMENTS_HISTORY: (state) => {
        return {...state, BAsData: null, BAsCurrentPage: null, BAsTotalPages: null, BAsError: null, BAsFetching: true};
    },
    FETCH_GET_BA_S_PAYMENTS_HISTORY_FAILED: (state, action) => {
        return {
            ...state,
            BAsData: null,
            BAsCurrentPage: null,
            BAsTotalPages: null,
            BAsError: action.payload,
            BAsFetching: false
        };
    },
    FETCH_GET_BA_S_PAYMENTS_HISTORY_SUCCESS: (state, action) => {
        return {
            ...state,
            BAsData: action.payload.content,
            BAsCurrentPage: action.payload.number,
            BAsTotalPages: action.payload.totalPages,
            BAsError: null,
            BAsFetching: false
        };
    },
    FETCH_GET_UNI_S_PAYMENTS_HISTORY: (state) => {
        return {
            ...state,
            universitiesData: null,
            universitiesCurrentPage: null,
            universitiesTotalPages: null,
            universitiesError: null,
            universitiesFetching: true
        };
    },
    FETCH_GET_UNI_S_PAYMENTS_HISTORY_FAILED: (state, action) => {
        return {
            ...state,
            universitiesData: null,
            universitiesCurrentPage: null,
            universitiesTotalPages: null,
            universitiesError: action.payload,
            universitiesFetching: false
        };
    },
    FETCH_GET_UNI_S_PAYMENTS_HISTORY_SUCCESS: (state, action) => {
        return {
            ...state,
            universitiesData: action.payload.content,
            universitiesCurrentPage: action.payload.number,
            universitiesTotalPages: action.payload.totalPages,
            universitiesError: null,
            universitiesFetching: false
        };
    },
    UPDATE_DATE_FROM_FILTER_FOR_BA_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, BAsDateFromFilter: action.payload};
    },
    UPDATE_DATE_TO_FILTER_FOR_BA_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, BAsDateToFilter: action.payload};
    },
    UPDATE_NAME_FILTER_FOR_BA_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, BAsNameFilter: action.payload};
    },
    UPDATE_DATE_FROM_FILTER_FOR_UNI_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, universitiesDateFromFilter: action.payload};
    },
    UPDATE_DATE_TO_FILTER_FOR_UNI_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, universitiesDateToFilter: action.payload};
    },
    UPDATE_NAME_FILTER_FOR_UNI_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, universitiesNameFilter: action.payload};
    },
    UPDATE_COUNTRY_FILTER_FOR_UNI_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, universitiesCountryFilter: action.payload};
    },
    UPDATE_COUNTRY_FILTER_FOR_BA_S_PAYMENTS_HISTORY: (state, action) => {
        return {...state, BAsCountryFilter: action.payload};
    }
}, initialState);

//- Selectors
export const getPaymentsHistory = state => state.paymentsHistory;

export const loadingBAsPaymentsHistory = state => getPaymentsHistory(state).BAsFetching;

export const getCurrentPageForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsCurrentPage;

export const getTotalPagesForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsTotalPages;

export const getBAsPaymentsHistoryData = state => {
    let data = getPaymentsHistory(state).BAsData;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => ({
            id: elem.transaction.transactionId,
            name: elem.target.firstName + ' ' + elem.target.lastName,
            paymentAmount: {
                currency: elem.transaction.delta.currency,
                amount: Math.abs(elem.transaction.delta.amount),
            },
            totalPay: elem.totalByTransactionType.map(transaction => ({
                ...transaction,
                amount: Math.abs(transaction.amount)
            })),
            paymentDate: elem.transaction.createdAt,
            comment: elem.transaction.metadata.comment === NO_COMMENT ? null : elem.transaction.metadata.comment
        })
    );
};

export const getDateFromFilterForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsDateFromFilter;
export const getDateToFilterForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsDateToFilter;
export const getNameFilterForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsNameFilter;
export const getCountryFilterForBAsPaymentsHistory = state => getPaymentsHistory(state).BAsCountryFilter;

export const loadingUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesFetching;

export const getCurrentPageForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesCurrentPage;

export const getTotalPagesForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesTotalPages;

export const getUniversitiesPaymentsHistoryData = state => {
    let data = getPaymentsHistory(state).universitiesData;
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, elem => ({
            id: elem.transaction.transactionId,
            name: elem.target.name,
            paymentAmount: {
                currency: elem.transaction.delta.currency,
                amount: -elem.transaction.delta.amount,
            },
            totalPay: elem.totalByTransactionType.map(transaction => ({...transaction, amount: -transaction.amount})),
            paymentDate: elem.transaction.createdAt,
            comment: elem.transaction.metadata.comment === NO_COMMENT ? null : elem.transaction.metadata.comment
        })
    );
};

export const getDateFromFilterForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesDateFromFilter;
export const getDateToFilterForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesDateToFilter;
export const getNameFilterForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesNameFilter;
export const getCountryFilterForUniversitiesPaymentsHistory = state => getPaymentsHistory(state).universitiesCountryFilter;


// WEBPACK FOOTER //
// ./src/reducers/systemPayments/paymentsHistory.js